'use client';
import { useId } from 'react';
import Checkbox from '../Checkbox';

type CheckboxItem = {
  defaultChecked: boolean;
  value: string;
  label: string;
};

type Props = {
  legend: string;
  name: string;
  className?: string;
  items: CheckboxItem[];
  handleChange?: (name: string, value: string) => void;
};

function MultiCheckbox(props: Props) {
  const { items, name, legend, handleChange, className } = props;
  const id = useId();

  return (
    <fieldset className={className}>
      <legend>{legend}</legend>
      {items.map(item => (
        <Checkbox
          key={item.label}
          id={`${id}-${name}-${item.value}`}
          label={item.label}
          value={item.value}
          defaultChecked={item.defaultChecked}
          onCheckedChange={() => handleChange?.(name, item.value)}
          variant='search'
        />
      ))}
    </fieldset>
  );
}

export default MultiCheckbox;

// <div key={item.label}>
//   <input
//     type="checkbox"
//     name={name}
//     value={item.value}
//     id={`${id}-${name}-${item.value}`}
//     defaultChecked={item.defaultChecked}
//     onChange={(e) => handleChange?.(e.target.name, e.target.value)}
//   />
//   <label htmlFor={`${id}-${name}-${item.value}`}>{item.label}</label>
// </div>
//
